// extracted by mini-css-extract-plugin
export default {"bodyContainer":"selection-confirm_bodyContainer__qW2qN","cardContainer":"selection-confirm_cardContainer__QcFhw"};